import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { AiOutlinePlus } from "react-icons/ai";
import TableHeader from "../../../components/Table/TableHeader";
import TableRow from "../../../components/Table/TableRow";
import PaginationControl from "../../../components/Table/PaginationControl";
import { IoIosArrowDown } from "react-icons/io";
import Avatar from "../../../components/Images/Avatar";

const Promotions = () => {
  const [searchSetting, setSearchSetting] = useState({
    page: 0,
    size: 10,
    status: "",
  });
  const { data, loading } = useFetch(
    `/v1/admin/promos?page=${searchSetting.page}&pageSize=${searchSetting.size}&status=${searchSetting.status}`,
  );

  const handleSearchSettingsChange = (event) => {
    const { name, value } = event.target;
    setSearchSetting((prevEntity) => ({
      ...prevEntity,
      [name]: value,
      page: 0,
    }));
  };

  return (
    <div>
      <PromosHeader />
      {loading ? (
        <span>Loading...</span>
      ) : (
        <div className="bg-white p-6 border border-gray-200">
          <PromoSearchActions onSelect={handleSearchSettingsChange} />
          <PromosTable data={data} />
          <PaginationControl
            searchSetting={searchSetting}
            setSearchSetting={setSearchSetting}
            paginationSettings={data.pageMetadata}
          />
        </div>
      )}
    </div>
  );
};

const PromosHeader = () => (
  <div className="flex justify-between mb-6 items-center">
    <span className="font-bold text-lg">PROMOTIONS</span>
    <Link to={"/notifications/promotions/create"} className={`submit-btn`}>
      <AiOutlinePlus />
      CREATE
    </Link>
  </div>
);

const PromoSearchActions = ({ onSelect }) => (
  <div className="grid justify-start grid-cols-1 xl:grid-cols-4 lg:grid-cols-2 gap-x-8 gap-2 mb-6">
    <div className="relative">
      <label className="relative text-[10px] text-gray-700">
        Status
        <select
          name="status"
          defaultValue="visible"
          onChange={onSelect}
          className="custom-select"
        >
          <option value="">All</option>
          <option value="visible">Visible</option>
          <option value="hidden">Hidden</option>
        </select>
        <IoIosArrowDown className="text-black absolute right-2.5 bottom-2.5 hover:cursor-pointer" />
      </label>
    </div>
  </div>
);

const PromosTable = ({ data }) => {
  const navigate = useNavigate();
  return (
    <div className="overflow-x-auto table-auto">
      <table className="w-full">
        <thead className="text-gray-700 text-xs bg-gray-100 ">
          <tr>
            <TableHeader name="ID" />
            <TableHeader name="TITLE" />
            <TableHeader name="LINK" />
            <TableHeader name="VISIBILITY" />
            <TableHeader name="CREATED AT" />
          </tr>
        </thead>
        <tbody>
          {data.data.map((promo, i) => (
            <tr
              key={i}
              onClick={() => navigate(`/notifications/promotions/${promo.id}`)}
              className="border-b text-xs hover:bg-gray-50 duration-300 hover:cursor-pointer"
            >
              <TableRow value={promo.id} />
              <TableRow
                value={
                  <div className="flex items-center gap-2">
                    <Avatar image={promo.image} />
                    <div>{promo.title}</div>
                  </div>
                }
              />
              <TableRow value={promo.link} />
              <TableRow
                value={
                  <div className="flex items-center gap-2">
                    <div
                      className={`p-1 rounded-full ${promo.isVisible ? "bg-green-500" : "bg-orange-500"}`}
                    />
                    {promo.isVisible ? "Visible" : "Hidden"}
                  </div>
                }
              />
              <TableRow
                value={new Date(promo.createdAt).toLocaleDateString()}
              />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Promotions;
